import httpRequest from "../../../axios/index";
import { ADMIN_DRIVERS } from "../../../constants/apiEndPoints";
import { toast } from "react-hot-toast";

const GetAllDrivers = async (
  setLoading,
  SetAllData,
  type = "",
  Search = "",
  Date = "",
  page = 1
) => {
  try {
    setLoading(true);
    let params = new URLSearchParams();

    if (type && type !== "All") {
      params.append("type", type.toLowerCase());
    }
    if (Search) {
      params.append("search", Search);
    }
    if (Date) {
      params.append("date", Date);
    }
    if (page) {
      params.append("page", page);
    }

    let url = `${ADMIN_DRIVERS}`;
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    const resp = await httpRequest.get(url);
    if (resp?.status === 200) {
      if (resp?.data?.message === "Success") {
        SetAllData(resp?.data);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

// get the customer details data

const GetDriverByID = async (setLoading, SetAllData, ID = "") => {
  try {
    setLoading(true);
    const resp = await httpRequest.get(`${ADMIN_DRIVERS}/${ID}`);
    if (resp?.status === 200) {
      if (resp?.data?.message === "Success") {
        SetAllData(resp?.data);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};
//   get the all Driver bookings

const GetDriverActionsByID = async (
  setLoading,
  SetAllData,
  ID = "",
  actions = ""
) => {
  try {
    setLoading(true);
    const resp = await httpRequest.get(`${ADMIN_DRIVERS}/${ID}/${actions}`);
    if (resp?.status === 200) {
      if (resp?.data?.message === "Success") {
        SetAllData(resp?.data);
      }
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Something went wrong");
  } finally {
    setLoading(false);
  }
};

export { GetAllDrivers, GetDriverByID, GetDriverActionsByID };
